<template>
  <div class="recurring-card-info">
    <div class="flex justify-between">
      <Skeletor
        height="20px"
        class="skeletonTag"
        width="100px"
        pill
      />
      <div>
        <Skeletor
          height="15px"
          class="skeletonTag"
          width="100px"
          pill
        />
        <Skeletor
          height="15px"
          class="skeletonTag"
          width="100px"
          pill
        />
      </div>
      <div class="flex"></div>
    </div>
    <div class="flex">
      <Skeletor
        height="10px"
        class="skeletonTag"
        width="100%"
        pill
      />
    </div>
    <div class="flex">
      <Skeletor
        height="10px"
        class="skeletonTag"
        width="100%"
        pill
      />
    </div>
    <div class="flex">
      <Skeletor
        height="40px"
        class="skeletonTag"
        width="80px"
        pill
      />
      <Skeletor
        height="40px"
        class="skeletonTag"
        width="80px"
        pill
      />
    </div>
  </div>
</template>

<style scoped>
.recurring-card-info {
  display: flex;
  flex-direction: column;
  width: 449px;
  padding: 16px 18px 24px 16px;
  border-radius: 12px;
  background: var(--White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
}
</style>
